import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-ae85544c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h2", {
    class: "title"
  }, "活动资讯", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title-desc"
  }, "点击查看更多活动资讯", -1);
});
var _hoisted_5 = {
  key: 0,
  class: "left-box"
};
var _hoisted_6 = {
  class: "right-box"
};
var _hoisted_7 = {
  key: 0,
  class: "right-box-1"
};
var _hoisted_8 = {
  key: 1,
  class: "right-box-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ImageInfomation = _resolveComponent("ImageInfomation");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", {
    class: "info-container",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.goToInfoList && _ctx.goToInfoList.apply(_ctx, args);
    })
  }, [_ctx.info1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_ImageInfomation, {
    image: _ctx.info1.newsCover,
    link: _ctx.info1.newsUrl,
    title: _ctx.info1.newsTitle,
    desc: _ctx.info1.newsSummary
  }, null, 8, ["image", "link", "title", "desc"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_ctx.info2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_ImageInfomation, {
    image: _ctx.info2.newsCover,
    link: _ctx.info2.newsUrl,
    title: _ctx.info2.newsTitle,
    desc: _ctx.info2.newsSummary
  }, null, 8, ["image", "link", "title", "desc"])])) : _createCommentVNode("", true), _ctx.info3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_ImageInfomation, {
    image: _ctx.info3.newsCover,
    link: _ctx.info3.newsUrl,
    title: _ctx.info3.newsTitle,
    desc: _ctx.info3.newsSummary
  }, null, 8, ["image", "link", "title", "desc"])])) : _createCommentVNode("", true)])])])]);
}